<template>
    <RadioGroup v-model="selected">
        <div class="mt-4 grid grid-cols-3 gap-2">
            <RadioGroupOption
                v-for="option in options" :key="option.value"
                as="template"
                :value="option.value"
                v-slot="{ checked, active }"
                :disabled="disabled"
            >
                <div
                    :class="[
                        checked
                            ? optionCheckedClass(option.value)
                            : 'border-gray-200 bg-white text-gray-600 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700/50',
                        active ? activeRingClass(option.value) : '',
                        'relative flex cursor-pointer items-center justify-between rounded-lg border px-3 py-2 transition-all focus:outline-none'
                    ]"
                >
                    <div class="flex items-center gap-2">
                        <span
                            class="h-1.5 w-1.5 rounded-full"
                            :class="checked ? optionDotClass(option.value) : 'bg-gray-400 dark:bg-gray-500'"
                        ></span>
                        <RadioGroupLabel
                            as="span"
                            class="text-sm font-medium"
                        >
                            {{ option.label }}
                        </RadioGroupLabel>
                    </div>
                    <CheckCircleIcon
                        v-if="checked"
                        class="h-4 w-4"
                        :class="optionIconClass(option.value)"
                        aria-hidden="true"
                    />
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { CheckCircleIcon } from '@heroicons/vue/24/outline';

export default {
    components: { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption, CheckCircleIcon },
    props: {
        options: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            selected: this.modelValue,
        }
    },

    methods: {
        optionCheckedClass(value) {
            const map = {
                approved: 'border-emerald-300 bg-emerald-50 text-emerald-700 dark:border-emerald-500/30 dark:bg-emerald-500/10 dark:text-emerald-400',
                warning: 'border-amber-300 bg-amber-50 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-400',
                rejected: 'border-red-300 bg-red-50 text-red-700 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-400',
            };
            return map[value] || map.approved;
        },
        activeRingClass(value) {
            const map = {
                approved: 'ring-2 ring-emerald-500/40',
                warning: 'ring-2 ring-amber-500/40',
                rejected: 'ring-2 ring-red-500/40',
            };
            return map[value] || 'ring-2 ring-indigo-500/40';
        },
        optionDotClass(value) {
            const map = {
                approved: 'bg-emerald-500',
                warning: 'bg-amber-500',
                rejected: 'bg-red-500',
            };
            return map[value] || 'bg-gray-500';
        },
        optionIconClass(value) {
            const map = {
                approved: 'text-emerald-600 dark:text-emerald-400',
                warning: 'text-amber-600 dark:text-amber-400',
                rejected: 'text-red-600 dark:text-red-400',
            };
            return map[value] || 'text-gray-500';
        },
    },

    watch: {
        selected(value) {
            this.$emit('update:modelValue', value);
        },
        modelValue(value) {
            this.selected = value;
        }
    },
}
</script>
